import { Controller } from '@hotwired/stimulus';
import { enter, leave } from '../../transition';

export default class extends Controller {
    static targets = ['content', 'icon']
    static values = { open: Boolean }

    connect() {
        if (!this.hasOpenValue) {
            this.openValue = false;
        }
        // Initial setup without animation
        this.toggleDOM(false);
    }
    
    openValueChanged(value, previousValue) {
        // Prevent animating on initial load
        const shouldAnimate = previousValue !== undefined;
        this.toggleDOM(shouldAnimate);
    }

    toggle() {
        this.openValue = !this.openValue;
    }

    toggleDOM(animate) {
        if (this.openValue) {
            // Expanded state
            if (this.hasIconTarget) {
                this.iconTarget.classList.add('rotate-180');
            }
            if (this.hasContentTarget) {
                this.contentTarget.classList.remove('hidden');
                if (animate) enter(this.contentTarget);
            }
        } else {
            // Collapsed state
            if (this.hasIconTarget) {
                this.iconTarget.classList.remove('rotate-180');
            }
            if (this.hasContentTarget) {
                if (animate) {
                    leave(this.contentTarget);
                } else {
                    this.contentTarget.classList.add('hidden');
                }
            }
        }
    }
}
